import { render, staticRenderFns } from "./taskList.vue?vue&type=template&id=eeda0850&scoped=true"
import script from "./taskList.vue?vue&type=script&lang=js"
export * from "./taskList.vue?vue&type=script&lang=js"
import style0 from "./taskList.vue?vue&type=style&index=0&id=eeda0850&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeda0850",
  null
  
)

export default component.exports